
import React from 'react'
export const logo = <img className="nav-panel-logo" width={50} src={require('../svg/logo.png')} />
export const logoHome = <img className="nav-panel-logo" width={350} src={require('../svg/logohome.png')} />
export const colorNavBar = () => '#fff';